export const dateFormats = ["MM-DD-YYYY", "DD-MM-YYYY"];
